import { gql } from 'graphql-tag';
import {
  MEMBER_FRAGMENT,
  NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT,
  CUSTOMER_FRAGMENT,
} from '../fragments';

/**
 * 场景一：首页初始化 - 合并 Query 定义
 *
 * 将原本 16 个串行请求合并为 2 个并行请求组：
 * - AppConfigInit: 公共配置（无需登录态，可走 Storage 缓存）
 * - UserDataInit: 用户数据（需登录态，每次实时请求）
 */

/**
 * 合并组 A：AppConfigInit（公共配置，无需登录态）
 * 适合走 Storage 缓存（cachedQuery），TTL 建议 5 分钟
 *
 * 合并的接口：
 * - settings (精选商品配置)
 * - customActiveChannel (店铺配置)
 * - getWeappDynamicRouteConfig (tabbar和功能页面配置)
 * - maxDiscountMembershipPlan (最大优惠的会员卡)
 * - getLevelConfig (会员等级配置)
 */
export const APP_CONFIG_INIT_QUERY = gql`
  query AppConfigInit($keyNames: [SettingKey]) {
    settings(keyNames: $keyNames) {
      id
      createdAt
      updatedAt
      key
      value
    }

    customActiveChannel {
      id
      customFields {
        shopName
        shopLogo
        updateShippingAddressLimitTime
        amount
        points
        enablePickup
        globalLotteryActivityId
      }
    }

    getWeappDynamicRouteConfig {
      tabbarConfig {
        text
        iconUrl
        selectedIconUrl
        routeValue
        path
        isBadge
      }
      eventTrackingConfig {
        eventScheme
        routeValue
      }
    }

    maxDiscountMembershipPlan {
      ...MembershipPlan
    }

    getLevelConfig {
      id
      levelsConfig {
        levels {
          name
          image
          description
          conditions {
            items {
              type
              value
              range {
                unit
                value
              }
            }
            judgeMethod
          }
          rights {
            type
            couponId
            value
          }
        }
      }
      customPageId
      enabled
    }
  }
  ${NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT}
`;

/**
 * 合并组 B：UserDataInit（用户数据，需登录态）
 * 每次冷启动实时请求，不走 Storage 缓存
 *
 * 合并的接口：
 * - activeCustomer (用户信息)
 * - getUserMember (会员信息)
 * - getVirtualCurrencyBalance (虚拟币余额)
 * - getOwnCustomlevel (会员等级)
 * - getDistributor (分销员数据)
 */
export const USER_DATA_INIT_QUERY = gql`
  query UserDataInit {
    activeCustomer {
      ...Customer
    }

    getUserMember {
      ...Member
    }

    getVirtualCurrencyBalance(virtualCurrencyCode: shoppingCredits)

    getOwnCustomlevel {
      id
      level
      activated
      nextLevelConditios {
        condition {
          type
          value
          range {
            unit
            value
          }
        }
        conditionValues {
          tradeAmount
          tradeCount
        }
        passed
      }
      distributeRecords {
        type
        couponId
        value
        sourceId
      }
    }

    getDistributor {
      id
      createdAt
      updatedAt
      name
      phone
      customer {
        ...Customer
      }
      orderTotal
      customerCount
      effectiveCustomerNum
    }
  }
  ${CUSTOMER_FRAGMENT}
  ${MEMBER_FRAGMENT}
`;

